<template>
  <div class="checkout-container overflow-x-hidden">
    <Checkout />
  </div>
</template>
<script lang="ts">
export default {
  name: 'CheckoutPage',
};
</script>

<script setup lang="ts">
import { onMounted } from 'vue';
import Checkout from '@/components/checkout/Checkout.vue';
import { useGtm } from '@/composables';

const { trackGtmEvent } = useGtm();

onMounted(() => {
  trackGtmEvent('Checkout page', 'Page', 'Loaded', 'Checkout page is loaded');
});
</script>
<style lang="scss" scoped>
.checkout-container {
  background-color: var(--v-cardBg-base);
  padding-top: 76px;
  min-height: 100%;

  @media screen and (max-width: 1264px) {
    min-height: 100vh;
  }
}
</style>
